

import ThemeButton from '@/components/ThemeButton.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as env from '@/common/environment';
import trackClick, { BTN_EVTS } from '@/directives/trackClick';

@Component({ components: { ThemeButton }, directives: { trackClick } })
export default class ACActions extends Vue {
  @Prop(Boolean) readonly disabled!: boolean;
  @Prop({ default: 'x' }) readonly maxLimit!: string|number

  readonly BTN_EVTS = BTN_EVTS;

  appName = env.get('appName')
}
